/**
 * SVG Redis icon
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const propTypes = {
  classes: PropTypes.shape({
    circleStyle: PropTypes.string.isRequired,
    redisStyle: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledRedisIcon({ ...props }) {
  const { classes, ...additionalProps } = props;
  const { circleStyle, redisStyle } = classes;
  return (
    <SvgIcon viewBox="0 0 120 120" {...additionalProps}>
      <circle className={circleStyle} cx="60" cy="60" r="55.5" />
      <g>
        <path
          className={redisStyle}
          d="M97.4,44.9c0,0.4,0,0.9,0,1.3c-0.9,0.9-1.7,2-2.8,2.6C84,54.6,73.3,60.2,62.7,65.9c-1.9,1-3.5,1-5.4,0
          c-10.6-5.7-21.3-11.3-31.9-17c-1.1-0.6-1.9-1.7-2.8-2.6c0-0.4,0-0.9,0-1.3c0.9-0.9,1.7-2.1,2.8-2.6c10.8-4.9,21.8-9.8,32.6-14.6
          c1.4-0.6,2.6-0.6,4,0c10.9,4.9,21.8,9.7,32.6,14.7C95.7,42.8,96.5,44,97.4,44.9z"
        />
        <path
          className={redisStyle}
          d="M97.4,58.2c0,0.6,0,1.1,0,1.7c-0.9,0.8-1.7,1.9-2.7,2.5C84,68.2,73.2,73.9,62.4,79.7c-1.7,0.9-3.1,0.9-4.8,0
          c-10.7-5.8-21.5-11.5-32.3-17.3c-1-0.6-1.8-1.7-2.7-2.5c0-0.6,0-1.1,0-1.7c1.6-2.6,2.9-2.9,5.6-1.5C38.4,62.2,48.5,67.6,58.6,73
          c1,0.5,1.7,0.5,2.7,0c10.1-5.4,20.3-10.8,30.4-16.2C94.5,55.3,95.8,55.6,97.4,58.2z"
        />
        <path
          className={redisStyle}
          d="M97.4,72.5c-0.8,0.8-1.5,1.7-2.5,2.3c-10.8,5.8-21.6,11.5-32.4,17.3c-1.7,0.9-3.2,0.9-5,0c-10.8-5.8-21.6-11.5-32.4-17.3
          c-1-0.5-1.7-1.5-2.5-2.3c0-0.6,0-1.1,0-1.7c1.4-2.6,2.9-3.1,5.5-1.6C38.3,74.6,48.5,80,58.7,85.5c1,0.5,1.6,0.5,2.6,0
          C71.5,80,81.7,74.6,91.9,69.2c2.7-1.4,4.1-1,5.5,1.6C97.4,71.4,97.4,71.9,97.4,72.5z"
        />
      </g>
    </SvgIcon>
  );
}

UnstyledRedisIcon.propTypes = propTypes;

const styles = (theme) => ({
  circleStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.white,
    stroke: theme.customColors.teal,
    strokeWidth: 7,
  },
  redisStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.teal,
  },
});

export default withStyles(styles)(UnstyledRedisIcon);
